/*
Author: LiuBo
Date: 2018-09-05
Desc: 缓存对象，根据config.js 中的配置，在框架启动时请求接口并缓存。由main.js 引入，通过this.$cache 调用
*/
import conf from "@/config/index";
import util from "@/util";
import req from "@/assets/js/req";
import store from "@/store";
import log from "@/assets/js/log";

let cacheData = {
    _session: [],
    _dict: {},
    _params: [],
    _user: [],
    _notice: [],
    _advertise: [],
    _sysparam: [],
    address:{
        citylists:JSON.parse(sessionStorage.getItem("citylists")) || [],
        countylists:JSON.parse(sessionStorage.getItem("countylists")) || [],
    }
};
let cacheConf = {};
const _request = function(it, resolve, reject) {
    let item = it.next();
    if(!item.done) {
        cacheConf[item.value.code] = item.value;
    }
    if (!item.done && item.value.load) {
        log.trace("读取缓存配置: ", item.value);
        if(JSON.parse(sessionStorage.getItem(item.value.code)) && item.value.code !== "_session"){
            log.trace("登录状态，不刷新缓存[" + item.value.code + "]");
            return _request(it, resolve, reject);
        }
        if (store.state.login.status && item.value.code === "_session") {
            log.trace("登录状态，不刷新缓存[" + item.value.code + "]");
            return _request(it, resolve, reject);
        }
        req({
            url: item.value.api,
            method: item.value.method,
            params: item.value.params || {},
            loader: false
        }).then(res => {
            if (item.value.code === "_dict") {
                const _x = res.record[0];
                const dict = {};
                for (let item of _x) {
                    if (dict[item.dictitem]) {
                        dict[item.dictitem].push(item);
                    } else {
                        dict[item.dictitem] = [item];
                    }
                }
                cacheData[item.value.code] = dict;
            } else if (item.value.code === "_params") {
                const _x = res.record[0];
                const _param = {};
                for (let item of _x) {
                    _param[item.paramname] = item.paramvalue;
                }
                cacheData[item.value.code] = _param;
            } else {
                cacheData[item.value.code] = res.record[0];
            }
            if (item.value.code === "_session") {
                sessionStorage.setItem("_a", JSON.stringify(res.record[0][0]));
                localStorage.setItem("_a", JSON.stringify(res.record[0][0]));
            }
            log.trace("缓存[" + item.value.code + "] 加载完成");
            _request(it, resolve, reject);
        }).catch(err => {
            if (err.code === "9999999" && item.value.code === "_session") {
                cacheData[item.value.code] = err.record[0];
                log.trace("缓存[" + item.value.code + "] 加载完成");
                _request(it, resolve, reject);
            } else {
                log.trace("缓存加载失败", err);
                resolve();
            }
        });
    } else {
        log.info("全部缓存处理完毕");
        resolve();
    }
};
export default {
    /* 初始化缓存对象（开始进行缓存）。本方法由main.js 调用，缓存全部处理完毕后才绘制入口页面
  @inParam 无
  @return [Object] Promise
  @promise-then 无参数，在缓存全部处理完毕后触发
  */
    init() {
        return new Promise((resolve, reject) => {
            let iterator = util.iterator(conf.cache);
            _request(iterator, resolve, reject);
        });
    },
    /* 刷新缓存
  @inParam [String] 缓存代码
  @return [Object] Promise
  @Promise-then [Array] 刷新后的缓存数据结果集
  */
    refresh(code) {
        let that = this;
        const _x = conf.cache.find(item=>{
            return item.code === code;
        });
        if (_x) {
            return new Promise((resolve, reject) => {
                req({
                    url: _x.api,
                    method: _x.method
                    // loader: false //默认添加loader
                }).then(res => {
                    if (code === "_dict") {
                        const _x = res.record[0];
                        const dict = {};
                        for (let item of _x) {
                            if (dict[item.dictitem]) {
                                dict[item.dictitem].push(item);
                            } else {
                                dict[item.dictitem] = [item];
                            }
                        }
                        cacheData[code] = dict;
                    } else if (code === "_params") {
                        const _x = res.record[0];
                        const _param = {};
                        for (let item of _x) {
                            _param[item.name] = item.value;
                        }
                        cacheData[code] = _param;
                    } else {
                        cacheData[code] = res.record[0];
                    }
                    let returnData = [];
                    for (let item of res.record[0]) {
                        returnData[returnData.length] = Object.assign({}, item);
                    }
                    switch (code) {
                    case "_session":
                        that.setSession(cacheData[code][0]);
                        break;
                    case "_user":
                        that.setUser(cacheData[code][0]);
                        break;
                    }
                    resolve(returnData);
                }).catch(err => reject(err));
            });
        }
    },
    /* 获取缓存数据
  @inParam [String] 缓存代码
  @return [Array] 缓存数据结果集
  */
    get(code) {
        if (code === undefined) {
            return cacheData;
        } else if (code.indexOf(0) === "_") {
            let returnData = [];
            for (let item of cacheData[code]) {
                returnData[returnData.length] = Object.assign({}, item);
            }
            return returnData;
        } else {
            return cacheData[code];
        }
    },
    /* 设置自定义缓存数据
  @inParam [String] 缓存代码, 不允许以下划线_开头（框架内部缓存数据以下划线开头）
  @inParam [Any] 要缓存的数据
  @return 无
  */
    set(code, val) {
        if (code.indexOf(0) === "_") {
            return false;
        } else {
            cacheData[code] = val;
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取会话token
  @inParam 无
  @return [String] 会话token
  */
    getSessionToken() {
        let storedSession = sessionStorage.getItem("_a");
        let storedToken = "";
        if (storedSession) {
            storedToken = JSON.parse(storedSession).token;
        }
        return (cacheData._session.length === 0) ? storedToken : cacheData._session[0].token;
    },
    /* 针对内部缓存数据提供的方法 : 获取本次会话的有效加密因子
  @inParam 无
  @return [String] 本次会话有效的加密因子
  */
    getSessionKey() {
        let storedSession = sessionStorage.getItem("_a");
        let storedKey = "";
        if (storedSession) {
            storedKey = JSON.parse(storedSession).key;
        }
        return (cacheData._session.length === 0) ? storedKey : cacheData._session[0].key;
    },
    /* 针对内部缓存数据提供的方法 : 设置会话信息
  @inParam [Object] 可选，会话信息对象. 包含token 和key 属性。如不提供则清空会话信息。
  本方法一般由store.dispatch('login') 和store.dispatch('logout') 内部调用。
  store.dispatch('login') 登录后立即调用，登录接口会返回key和token，需要将这些数据存入缓存便于框架后续使用
  store.dispatch('logout') 注销、刷新、超时后调用，将在清空会话信息后再次刷新会话
  @return 无
  */
    setSession(d) {
        if (d) {
            cacheData._session = [{
                token: d.token,
                key: d.key
            }];
            sessionStorage.setItem("_a", "{\"token\":\"" + d.token + "\",\"key\":\"" + d.key + "\"}");
            localStorage.setItem("_a", "{\"token\":\"" + d.token + "\",\"key\":\"" + d.key + "\"}");
        } else {
            cacheData._session = [];
            sessionStorage.removeItem("_a");
            localStorage.removeItem("_a");
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取数据字典
  @inParam [String] 字典编号
  @inParam [String] 可选，字典项取值
  @return [Array] 如果未提供字典项取值，则返回该字典编号下的所有字典项结果集
  @return [String] 如果同时提供了字典编号和字典取值，则返回该字典编号下，取值为subItem 的字典项的subitemname
  */
    getDict(dictItem, subItem) {
        if (dictItem === undefined) {
            return cacheData._dict;
        }
        if (dictItem === "100017") {
            cacheData._dict[dictItem] = [
                {sysid: "4", dictitem: "100017", subitem: "04", subitemname: "C4-积极型", remark: "风险承受能力"},
                {sysid: "4", dictitem: "100017", subitem: "05", subitemname: "C5-激进型"},
                {sysid: "4", dictitem: "100017", subitem: "01", subitemname: "C1-安逸型"},
                {sysid: "4", dictitem: "100017", subitem: "02", subitemname: "C2-保守型"},
                {sysid: "4", dictitem: "100017", subitem: "03", subitemname: "C3-稳健型"}
            ];
        }
        if (dictItem === "110143") {
            cacheData._dict[dictItem] = [
                {sysid: "4", dictitem: "110143", subitem: "01", subitemname: "R1-低", remark: "产品风险等级"},
                {sysid: "4", dictitem: "110143", subitem: "02", subitemname: "R2-中低"},
                {sysid: "4", dictitem: "110143", subitem: "03", subitemname: "R3-中"},
                {sysid: "4", dictitem: "110143", subitem: "04", subitemname: "R4-中高"},
                {sysid: "4", dictitem: "110143", subitem: "05", subitemname: "R5-高"}
            ];
        }
        if (subItem === undefined) {
            return cacheData._dict[dictItem];
        } else {
            if (String(subItem).indexOf(",") > -1) {
                let _x = "";
                const _itemArr = String(subItem).split(",");
                for (let i of _itemArr) {
                    for (let item of cacheData._dict[dictItem]) {
                        if (item.subitem.trim() === String(i)) {
                            _x += Object.assign({}, item).subitemname + ",";
                            break;
                        }
                    }
                }
                return _x.substr(0, _x.length - 1);
            }
            for (let item of cacheData._dict[dictItem]) {
                if (item.subitem.trim() === String(subItem)) {
                    return Object.assign({}, item).subitemname;
                }
            }
            return "";
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取公司信息
  @inParam [String] 可选，指定要获取的公司信息参数名
  @return [Object] 如未提供参数名，则返回内含所有公司信息的Object, key为参数名，value 为参数值
  @return [String] 如提供了参数名，则返回指定参数名的参数值
  */
    getCompanyInfo(key) {
        let info = cacheData._params;
        return (key === undefined) ? info : info[key];
    },
    /* 针对内部缓存数据提供的方法 : 获取公司信息
 @inParam [String] 可选，指定要获取的公司信息参数名
 @return [String] 如提供了参数名，则返回指定参数名的参数值
 */
    getAdvertiseInfo(key) {
        let info = cacheData._advertise || [];
        const _x = info.filter(item => {
            return item.bannertype === String(key);
        });
        return _x || [];
    },
    /* 针对内部缓存数据提供的方法 : 设置用户信息
  @inParam [Object] 用户信息键值对。本方法一般应在登录后获取到用户信息、或用户信息发生改变后立即调用。
  @return 无
  */
    setUser(d) {
        // cacheData._user = [Object.assign({}, d)]
        sessionStorage.setItem("_c", JSON.stringify(d));
    },
    /* 针对内部用户信息缓存数据更新提供的方法 : 更新用户信息(网上交易/APP/微信/网站需要此方法更新用户信息, UMP不需要)
  @return 无
  */
    refreshUser(cb) {
        const _this = this;
        this.refresh("_user").then(res => {
            _this.setUser(res[0]);
            if (cb) {
                cb.call(this);
            }
        });
    },
    /* 针对内部缓存数据提供的方法 : 获取用户信息
  @inParam 无
  @return [Object] 用户信息键值对
  */
    getUser() {
        // return (cacheData._user.length === 0) ? {} : Object.assign(cacheData._user[0])
        return JSON.parse(sessionStorage.getItem("_c") || "{}");
    },
    /* 针对内部缓存数据提供的方法 : 清空用户信息
  @inParam 无
  @return 无
  */
    clearUser() {
        // cacheData._user = []
        sessionStorage.removeItem("_c");
    },
    /* 获取系统参数(UMP/JDAC 需要，其他产品不需要此方法)
  @inParam [String] pid 参数编号\
  return 参数值
  */
    getSysParam(pid) {
        if (pid === undefined) {
            return cacheData._sysparam;
        } else {
            for (let item of cacheData._sysparam) {
                if (item.paramid === pid) {
                    return item.paramvalue;
                }
            }
        }
    },
    /* 获取业务是否需要校验密码参数(网上交易需要，其他产品不需要此方法)
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getPwdCheck(pid) {
        if (!pid || pid === "") return false;
        const _check = cacheData._params.needpwdbiz ? cacheData._params.needpwdbiz : "";
        return _check && _check.indexOf(pid) > -1;
    },
    /* 获取对应路由是否存在温馨提示
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getNotice(pid) {
        if (!pid || pid === "") return false;
        const _check = cacheData._notice || [];
        const _x = _check.find(item => {
            return item.route === pid;
        });
        return _x || "";
    },
    /* 获取现金宝基金代码(网上交易需要，其他产品不需要此方法)
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getXjbCode() {
        return cacheData._params.xjbfundcode ? cacheData._params.xjbfundcode.replace(",", "") : "";
    },
    /* 针对内部缓存数据提供的方法 : 获取增值模块状态
  @inParam [String] 模块编号
  @return [Object] 模块编号状态
  */
    getStatus(code) {
        for (let list of cacheData._modulestatus) {
            if (list.modulecode == conf.modulecode[code]) {
                return list.status;
            }
        }
    },
    /* 获取常用邮箱配置间*/
    getEmailSuffix(){
        const email_suffix = cacheData._params.email_suffix;
        return email_suffix;
    },
    /* 获取交易页面信批文件强制阅读的配置时间*/
    getReadTime(){
        const readfile_time = cacheData._params.readfile_time;
        return readfile_time;
    },
    getOcrFileSize() {
        const upFileSize = cacheData._params.upload_file_size;
        return upFileSize;
    },
    getChannelLimit(channel,key){
        const limit = cacheData._params[channel + '_limit_' + key];
        return limit && limit.trim();
    },
    // 获取_params数据
    getParams(key) {
        let info = cacheData._params;
        return (key === undefined) ? info : info[key];
    },

    // 城市信息载入缓存
    initCityCountyList(){
        let address = this.get("address");
        let citylists = cacheData["address"]["citylists"];
        let countylists = cacheData["address"]["countylists"];
        if(citylists instanceof Array){//没有数据时为空数组
            util.request("common/citylist", { provinceid: "" }).then(res => {
                let citylists = res.data && res.data[1] || [];
                citylists.forEach(item => {
                    item["citylist"] = JSON.parse(item["citylist"]);
                })
                //数组转成provingid:citylist对象，方便查找
                // cacheData["address"]["citylists"] = util.convertArrToObj(citylists,"provinceid","citylist");
                // sessionStorage.setItem("citylists",JSON.stringify(cacheData["address"]["citylists"]));
                address["citylists"] = util.convertArrToObj(citylists,"provinceid","citylist");
                sessionStorage.setItem("citylists",JSON.stringify(address["citylists"]));
            });
        }
        if(countylists instanceof Array){
            util.request("common/countylist", { cityid: "" }).then(res => {
                let countylists = res.data && res.data[1] || [];
                countylists.forEach(item => {
                    item["countylist"] = JSON.parse(item["countylist"]);
                })
                // cacheData["address"]["countylists"] = util.convertArrToObj(countylists,"cityid","countylist");
                // sessionStorage.setItem("countylists",JSON.stringify(cacheData["address"]["countylists"]));
                address["countylists"] = util.convertArrToObj(countylists,"cityid","countylist");
                sessionStorage.setItem("countylists",JSON.stringify(address["countylists"]));
            });
        }
    }
};
